import React from "react";
import "./entities.scss";
import EntitiesListing from "components/entities/EntitiesListing";

function AdminEntities() {
  return <EntitiesListing />;
}

export default AdminEntities;
